// @flow
import {stopSubmit} from 'redux-form';
import {call, put, takeEvery} from 'redux-saga/effects';
import {tripica} from '../../../api';
import config from '../../../config';
import HandleErrorService from '../../../lib/handleError';
import I18n from '../../../lib/i18n';
import {setLoading} from '../../LoadingStatus';
import {
  goToNextActivationPage,
  goToNextEsimPage,
} from '../actions';
import type {SignUpPhoneNumberActionType} from './actions';
import {setKeptPhoneNumber} from './actions';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* confirmKeptPhoneNumberSaga(
  action: SignUpPhoneNumberActionType,
): Generator<*, *, *> {
  if (action.type !== 'SIGNUP_CONFIRM_KEPT_PHONE_NUMBER') return;
  yield put(setLoading('confirmKeptPhoneNumber', true));
  try {
    const formattedPhoneNumber =
      action.payload.numberConfig.phoneNumber.replace(/[^\d]/g, '');
    if (config.enableCheckOperator) {
      yield call([tripica, 'getOperator'], formattedPhoneNumber);
    }
    yield put(
      setKeptPhoneNumber(
        formattedPhoneNumber,
        action.payload.numberConfig.rioNumber,
      ),
    );
    if (action.payload.isActivationPath) {
      yield put(goToNextActivationPage());
    } else {
      yield put(goToNextEsimPage());
    }
  } catch (e) {
    yield put(
      stopSubmit('keepNumber', {
        phoneNumber: HandleErrorService.getErrorMessage(e, e =>
          I18n.t('SignUp.ChooseNumber.cannotDoPortability'),
        ),
      }),
    );
    WizzeeLog.warn('[saga] confirmKeptPhoneNumberSaga', e);
  } finally {
    yield put(setLoading('confirmKeptPhoneNumber', false));
  }
}

export default function* (): Generator<*, *, *> {
  yield* [
    takeEvery('SIGNUP_CONFIRM_KEPT_PHONE_NUMBER', confirmKeptPhoneNumberSaga),
  ];
}
